import { appMessagesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("app-message"),
  endpoint: "app-messages",
  operations: appMessagesOps,
  roleView: [ROLE.APP_MESSAGE_ADMIN, ROLE.APP_MESSAGE_VIEW],
  roleAdmin: [ROLE.APP_MESSAGE_ADMIN],
  singularName: (t) => t("App message"),
  name: (t) => t("App messages"),
  syncCustomerFilter: true,
});

export default conf;
